import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
              关于我们
            </h2>
            <p className="mt-3 text-sm text-foreground-500 text-center">
              了解丫丫漫画的故事与使命
            </p>

            <div className="mt-10 space-y-5">
              {aboutData.paragraphs.map((para, idx) => (
                <p
                  key={idx}
                  className="text-sm md:text-base text-foreground-700 leading-relaxed"
                >
                  {para}
                </p>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6 text-center">
              <div className="p-5 bg-background-100 rounded-2xl border border-background-200/70">
                <span className="block text-3xl font-heading text-primary-600">2019</span>
                <span className="block mt-1 text-xs text-foreground-500">成立年份</span>
              </div>
              <div className="p-5 bg-background-100 rounded-2xl border border-background-200/70">
                <span className="block text-3xl font-heading text-accent-600">10万+</span>
                <span className="block mt-1 text-xs text-foreground-500">漫画作品</span>
              </div>
              <div className="p-5 bg-background-100 rounded-2xl border border-background-200/70">
                <span className="block text-3xl font-heading text-secondary-600">500万+</span>
                <span className="block mt-1 text-xs text-foreground-500">注册用户</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}